function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

var _excluded = ["link"];

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

// @ts-nocheck
import { Component } from "react";
import h from "@macrostrat/hyper";
import { Card, Classes } from "@blueprintjs/core";
import { APIResultView } from "../api";
import { LinkCard } from "../link-card";
import { AuthorList } from "../citations";

var VolumeNumber = function VolumeNumber(props) {
  var volume = props.volume,
      number = props.number;
  var _ = [];

  if (volume != null && volume !== "") {
    _.push(h("span.volume", null, volume));
  }

  if (number != null && number !== "") {
    _.push("(");

    _.push(h("span.number", number));

    _.push(")");
  }

  if (_.length === 0) {
    return null;
  }

  _.push(", ");

  return h("span", null, _);
};

function InnerCard(props) {
  var title = props.title,
      author = props.author,
      doi = props.doi,
      journal = props.journal,
      identifier = props.identifier,
      volume = props.volume,
      number = props.number,
      year = props.year;

  try {
    var _identifier$find = identifier.find(function (d) {
      return d.type === "doi";
    });

    doi = _identifier$find.id;
  } catch (error) {
    doi = null;
  }

  var names = author.map(function (d) {
    var n = d.name.split(", ");
    n.reverse();
    return n.join(" ");
  });
  return h([h(AuthorList, {
    names: names,
    limit: 3
  }), ", ", h("span.title", title), ", ", h("span.journal", journal), ", ", h(VolumeNumber, {
    volume: volume,
    number: number
  }), h("span.year", year), ", ", h("span.doi-title", "doi: "), h("span.doi", doi)]);
}

function GeoDeepDiveSwatchInnerBare(props) {
  return h(Card, {
    interactive: false,
    className: "gdd-article"
  }, [// @ts-ignore
  h(InnerCard, props)]);
}

var GeoDeepDiveSwatch = /*#__PURE__*/function (_Component) {
  _inherits(GeoDeepDiveSwatch, _Component);

  var _super = _createSuper(GeoDeepDiveSwatch);

  function GeoDeepDiveSwatch() {
    _classCallCheck(this, GeoDeepDiveSwatch);

    return _super.apply(this, arguments);
  }

  _createClass(GeoDeepDiveSwatch, [{
    key: "render",
    value: function render() {
      var url;

      var _this$props = this.props,
          link = _this$props.link,
          rest = _objectWithoutProperties(_this$props, _excluded);

      try {
        var _link$find = link.find(function (d) {
          return d.type === "publisher";
        });

        url = _link$find.url;
      } catch (error) {
        url = null;
      }

      return h(LinkCard, {
        href: url,
        target: "_blank",
        className: "gdd-article"
      }, // @ts-ignore
      h(InnerCard, rest));
    }
  }]);

  return GeoDeepDiveSwatch;
}(Component);

function GeoDeepDiveRelatedTerms(props) {
  var data = props.data;
  return h([h("h1", "Related Terms"), h("ul#related_terms", data.map(function (item) {
    return h("li", item[0]);
  }))]);
}

var PlaceholderReference = function PlaceholderReference() {
  return h(Card, {
    className: "gdd-article ".concat(Classes.SKELETON)
  }, "word ".repeat(35));
};

var GDDReferenceCard = function GDDReferenceCard(props) {
  var docid = props.docid;
  return h(APIResultView, {
    route: "https://geodeepdive.org/api/articles",
    params: {
      docid: docid
    },
    opts: {
      unwrapResponse: function unwrapResponse(res) {
        return res.success.data[0];
      },
      memoize: true
    },
    placeholder: PlaceholderReference
  }, function (data) {
    try {
      return h(GeoDeepDiveSwatch, data);
    } catch (error) {
      return null;
    }
  });
};

export { GDDReferenceCard, GeoDeepDiveSwatch, GeoDeepDiveSwatchInnerBare, GeoDeepDiveRelatedTerms };